/**
 * Notification utility for offline sync and other local notifications
 */

// Check if notifications are supported and permission status
export const getNotificationStatus = () => {
  if (!('Notification' in window)) {
    return { supported: false, permission: 'unsupported' };
  }
  return { supported: true, permission: Notification.permission };
};

// Request notification permission
export const requestNotificationPermission = async () => {
  if (!('Notification' in window)) {
    console.log('Notifications not supported');
    return false;
  }

  if (Notification.permission === 'granted') {
    return true;
  }

  if (Notification.permission !== 'denied') {
    const permission = await Notification.requestPermission();
    return permission === 'granted';
  }

  return false;
};

// Send notification via Service Worker
export const sendNotification = async (title, body, data = {}) => {
  // First check if we have permission
  const hasPermission = await requestNotificationPermission();
  if (!hasPermission) {
    console.log('Notification permission denied');
    return false;
  }

  // Check if service worker is available
  if (!('serviceWorker' in navigator)) {
    console.log('Service worker not supported');
    return false;
  }

  try {
    const registration = await navigator.serviceWorker.ready;
    
    // Send message to service worker to show notification
    registration.active.postMessage({
      type: 'SHOW_SYNC_NOTIFICATION',
      title,
      body,
      data
    });
    
    return true;
  } catch (error) {
    console.error('Error sending notification:', error);
    return false;
  }
};

// Send offline sync success notification
export const sendSyncSuccessNotification = async (syncedCount, totalAmount) => {
  const formatCurrency = (amount) =>
    new Intl.NumberFormat("id-ID", { style: "currency", currency: "IDR", minimumFractionDigits: 0 }).format(amount || 0);

  return sendNotification(
    'Sinkronisasi Berhasil',
    `${syncedCount} pembayaran offline berhasil disinkronkan. Total: ${formatCurrency(totalAmount)}`,
    {
      type: 'offline_sync_success',
      target: 'petugas',
      syncedCount,
      totalAmount
    }
  );
};

// Send offline sync partial notification (some failed)
export const sendSyncPartialNotification = async (syncedCount, failedCount) => {
  return sendNotification(
    'Sinkronisasi Sebagian',
    `${syncedCount} berhasil, ${failedCount} gagal disinkronkan. Buka aplikasi untuk detail.`,
    {
      type: 'offline_sync_partial',
      target: 'petugas',
      syncedCount,
      failedCount
    }
  );
};

// Send offline data download notification
export const sendDownloadNotification = async (billsCount) => {
  return sendNotification(
    'Data Offline Siap',
    `${billsCount} data tagihan berhasil diunduh. Anda bisa bekerja offline hari ini.`,
    {
      type: 'offline_download_success',
      target: 'petugas',
      billsCount
    }
  );
};

export default {
  getNotificationStatus,
  requestNotificationPermission,
  sendNotification,
  sendSyncSuccessNotification,
  sendSyncPartialNotification,
  sendDownloadNotification
};
